import type { ConfigProviderProps } from 'antd/es/config-provider';

import { css } from 'config/emotionCss';
import colors from 'config/theme/colors';

const itemStyle = css`
  &:not(.ant-pagination-item-active) {
    border: 1px solid ${colors['@border-color-split']};
  }

  &.ant-pagination-disabled {
    background-color: ${colors['@body-bg']};
  }

  .ant-pagination-item-link {
    line-height: 1;
  }
`;

const rootStyle = css`
  .ant-pagination-jump-next {
    margin-inline-start: 4px;
  }
`;

const paginationConfig: ConfigProviderProps['pagination'] = {
  classNames: { root: rootStyle, item: itemStyle },
  showSizeChanger: true,
};

export default paginationConfig;
